import React from 'react';
import type { ReviewResponse } from './types';

interface ReviewCardProps {
  review: ReviewResponse;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ review }) => {
  return (
    <div className="bg-[#3a3a3a] rounded-lg p-4 border border-[#4a4a4a]">
      {/* Review Summary */}
      <div className="mb-3">
        <p className="text-sm text-gray-300 italic">{review.target_review_summary}</p>
      </div>

      {/* Suggested Response Section */}
      <div className="mb-3">
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-sm font-normal text-[#ffffff]">Suggested Response</h4>
          <button className="px-3 py-1 font-medium text-brand-primary cursor-pointer text-[10px] rounded transition-colors">
            Post Reply
          </button>
        </div>
        <div className="bg-[#2a2a2a] rounded p-3 border border-[#4a4a4a]">
          <p className="text-xs text-white leading-relaxed">{review.suggested_response}</p>
        </div>
      </div>

      {/* Strategy Section */}
      <div>
        <h4 className="text-sm font-normal text-[#ffffff] mb-2">Strategy</h4>
        <div className="bg-[#2a2a2a] rounded p-3 border border-[#4a4a4a]">
          <p className="text-xs text-white leading-relaxed">{review.response_strategy}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
